// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/merchandising/medicine/v1/medicine.proto (package stailer_service_specification.merchandising.medicine.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/merchandising/medicine/v1/medicine.proto.
 */
const file_stailer_service_specification_merchandising_medicine_v1_medicine = /*@__PURE__*/
  fileDesc("CkZzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9tZXJjaGFuZGlzaW5nL21lZGljaW5lL3YxL21lZGljaW5lLnByb3RvEjdzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5tZXJjaGFuZGlzaW5nLm1lZGljaW5lLnYxIskDCghNZWRpY2luZRLvAQoVc2hvd19kcnVnX2luZm9ybWF0aW9uGAEgASgIQs8BkoIZoAHljLvolqzlk4HplqLpgKPmg4XloLHvvIjllY/oqLrjg7vlkIzmhI/jg5Xjg63jg7zjgIHljLvolqzlk4Hmg4XloLHjg4bjgq3jgrnjg4gvUERG44CB5rOo5paH56K66KqN55S76Z2i44Gu5rOo5oSP5LqL6aCF77yJ44KS6KGo56S644GZ44KL44GL44KS5oyH5a6a44GX44G+44GZ44CCqoIZHuWMu+iWrOWTgemWoumAo+aDheWgseOBruihqOekuriCGQPAghkBEsoBChxzaG93X3NlbGZfbWVkaWNhdGlvbl9zdXBwb3J0GAIgASgIQqMBkoIZY+azqOaWh+eiuuiqjeeUu+mdouOBp+OCu+ODq+ODleODoeODh+OCo+OCseODvOOCt+ODp+ODs+eojuWItuOCkuihqOekuuOBmeOCi+OBi+OCkuaMh+WumuOBl+OBvuOBmeOAgqqCGTDjgrvjg6vjg5Xjg6Hjg4fjgqPjgrHjg7zjgrfjg6fjg7PnqI7liLbjga7ooajnpLq4ghkDwIIZAWIGcHJvdG8z", [file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.merchandising.medicine.v1.Medicine.
 * Use `create(MedicineSchema)` to create a new message.
 */
const MedicineSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_merchandising_medicine_v1_medicine, 0);


exports.file_stailer_service_specification_merchandising_medicine_v1_medicine = file_stailer_service_specification_merchandising_medicine_v1_medicine;
exports.MedicineSchema = MedicineSchema;
